const employeeId = {
	employee: {
		title: "Karyawan",
		subtitle: "Ringkasan daftar karyawan",
		table_title: "Data Karyawan",
		empty_title: "Tidak ada data karyawan",
		empty_description: "Silakan tambahkan karyawan baru.",
		columns: {
			created_at: "Dibuat Pada",
			name: "Nama karyawan",
			email: "Email",
			store: "Toko",
			position: "Jabatan",
			balance: "Saldo",

			status: "Status",
		},
		status: {
			active: "Aktif",
			inactive: "Non Aktif",
		},
		add: {
			button: "Tambah karyawan",
			title: "Tambah karyawan",
			description: "Tambah data karyawan baru",
			success: "Berhasil!",
			success_description: "{name} berhasil ditambahkan!",
			error: "Terjadi kesalahan!",
			error_description: "Coba lagi beberapa saat!",
		},
		edit: {
			title: "Edit karyawan",
			description: "Edit data karyawan",
			section_info: "Informasi karyawan",
			section_pic: "Informasi PIC",
			section_settings: "Pengaturan karyawan",
			section_rounding: "Pengaturan Pembulatan",
			section_footer_printer: "Footer Printer",
			saving: "Menyimpan...",
			save: "Simpan Perubahan",
		},
		delete: {
			title: "Hapus karyawan",
			confirm: "Apakah anda yakin ingin menghapus {name}?",
			button: "Hapus",
		},
		form: {
			name: "Nama karyawan",
			email: "Email Karywan",
			email_field_description:
				"Password akan dikirim via email. Pastikan email yang diinput VALID!",
			choose_store: "Pilih toko",
			choose_role: "Pilih role",
			placement_and_role: "Penempatan & Role",
		},
		actions: {
			cancel: "Batal",
			save: "Simpan",
			saving: "Menyimpan...",
			delete: "Hapus",
			deleting: "Menghapus...",
		},
	},
};

export default employeeId;
